import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';

/**
 * 定义 Logo 组件
 */
class Logo extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    /**
     * 渲染组件
     */
    render() {
        const {
            content: { url, img, breadcrumbsData },
        } = this.props;

        return (
            <React.Fragment>
                <div className={styles.logo}>
                    <a href={url} target="_blank">
                        <img src={img} width="203" height="40" />
                    </a>
                </div>
                <div className={styles.breadcrumbs}>
                    {breadcrumbsData.map((item, index) => (
                        <a key={index} href={item.url} target="_blank">
                            {` ${item.title} ${breadcrumbsData.length === index + 1 ? '' : '|'}`}
                        </a>
                    ))}
                </div>
            </React.Fragment>
        );
    }
}

export default errorBoundary(Logo);
